
import state from './moduleOpportunityFieldsManagementState'
import mutations from './moduleOpportunityFieldsManagementMutations'
import actions from './moduleOpportunityFieldsManagementActions'
import getters from './moduleOpportunityFieldsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

